import { Injectable, inject } from '@angular/core';

import { DisplayType, Fixture, OptionMarket, OrderType, ParameterType } from '@cds/betting-offer';
import { ExtendedDisplayType, Tv2MarketParameters } from '@frontend/sports/betting-offer/feature/model';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { NativePrice } from '@frontend/sports/odds/feature/native-price';

@Injectable({
    providedIn: 'root',
})
export class PriceBoostService {
    sitecore = inject(Sitecore);

    filterPriceBoostFixtures(fixtures: Fixture[]): Fixture[] {
        return fixtures.filter((fixture) => {
            fixture.optionMarkets = this.filterPriceboostOptionMarkets(fixture.optionMarkets);
            return fixture.optionMarkets.length;
        });
    }

    private filterPriceboostOptionMarkets(optionMarkets: OptionMarket[]): OptionMarket[] {
        return optionMarkets
            .map((optionMarket) => {
                optionMarket.options = optionMarket.options.filter(
                    (option) => option.boostedPrice && NativePrice.fromNativePrice(option.boostedPrice).greaterThan(1),
                );
                optionMarket.grouping.detailed = [
                    {
                        displayType: DisplayType.Regular,
                        orderType: OrderType.None,
                        marketHelpPath: '',
                        marketGroupId: '',
                        marketGroupItemId: '',
                    },
                ];
                optionMarket.parameters = [
                    {
                        key: Tv2MarketParameters.MarketType,
                        type: ParameterType.String,
                        value: ExtendedDisplayType.AutomatedPriceBoost,
                    },
                ];

                return optionMarket;
            })
            .filter((optionMarket) => optionMarket.options.length);
    }
}
